const React = require("react");

const Config = ({ children }) => <div className="config">{children}</div>;

Config.displayName = "Config";

export default Config;
